"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import TableToolBarStoreClass from "Stores/TableToolBarStore";
import classNames from 'classnames';
import { tbUpdateFormUUID } from "Actions/Table/TableToolBarActions";

var styles = function styles(theme) {
  return {
    spacer: {
      marginTop: '13px'
    },
    spacerInside: {
      marginTop: '0'
    },
    actions: {
      color: theme.palette.text.secondary
    },
    title: {
      flex: '0 0 auto'
    },
    toolbarStyle: {
      minHeight: 'auto',
      maxHeight: '45px',
      marginBottom: '8px'
    }
  };
};

var TableToolBar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TableToolBar, _React$Component);

  function TableToolBar(props) {
    var _this;

    _classCallCheck(this, TableToolBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableToolBar).call(this, props));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(TableToolBar, [{
    key: "_onChange",
    value: function _onChange() {
      this.setState(this.store.getList());
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.$toolbar = $(this.el).dxToolbar({});
      this.formUUID = this.props.formUUID;
      this.store = new TableToolBarStoreClass(this.$toolbar, this.props.formUUID, this.props.formTableMode, this.props.formType, this.props.viewMode, this.props.parentUUID, this.props.isReadOnly);
      this.store.loadButtons(this.props.formID);
      this.store.addChangeListener(this._onChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.$toolbar.dxToolbar('dispose');
      this.$toolbar.remove();
      this.store.unregister();
      this.store.removeChangeListener(this._onChange);
      this.store.destructor();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      //обновляем formUUID в компоненте, кроме подченненыъ таблиц
      if (!this.props.formTableMode && this.formUUID !== nextProps.formUUID) {
        setTimeout(function () {
          tbUpdateFormUUID(_this2.props.formUUID, nextProps.formUUID);
        });
        this.formUUID = nextProps.formUUID;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          formID = _this$props.formID,
          formTableMode = _this$props.formTableMode;
      return React.createElement(Toolbar, {
        className: classNames(classes.toolbarStyle, 'table-toolbar')
      }, React.createElement("div", {
        className: classNames(formTableMode ? classes.spacerInside : classes.spacer)
      }), React.createElement("div", {
        className: "table-form-buttons-panel",
        id: "table-form-buttons-panel-".concat(formID)
      }, React.createElement("div", {
        id: "toolbar-".concat(formID),
        ref: function ref(r) {
          return _this3.el = r;
        }
      })));
    }
  }]);

  return TableToolBar;
}(React.Component);

TableToolBar.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};
export default withStyles(styles, {
  withTheme: true
})(TableToolBar);